
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import CustomSkillsMultiselectNew from "@/components/autocompleteMultiselects/customOptions/CustomSkillsMultiselectNew.vue";
import CustomSoftSkillsMultiselectNew from "@/components/autocompleteMultiselects/customOptions/CustomSoftSkillsMultiselectNew.vue";
import IndustriesMultiselect from "@/components/autocompleteMultiselects/IndustriesMultiselectNew.vue";
import LanguagesMultiselect from "@/components/autocompleteMultiselects/LanguagesMultiselectNew.vue";
import JobTitleMultiselect from "@/components/autocompleteMultiselects/JobTitleMultiselect.vue";
import CurrencySelect from "@/components/autocompleteMultiselects/CurrencySelect.vue";
import RateUnitSelect from "@/components/autocompleteMultiselects/RateUnitSelect.vue";
import InputRangeFilter from "@/components/filters/InputRangeFilter.vue";
import {
  Industry,
  Language,
  User_Industry,
  User_Language,
  User_Skill,
  User,
  User_Profile_By_Management,
  User_Experience,
  User_Education,
  User_Certification,
} from "@/generated/graphql";
import ProfileWebsite from "@/components/profile/ProfileWebsite.vue";
import ProfileDemoReel from "@/components/profile/ProfileDemoReel.vue";
import ProfileExperience from "@/components/profile/experiences/ProfileExperience.vue";
import ProfileEducation from "@/components/profile/educations/ProfileEducation.vue";
import ProfileCertification from "@/components/profile/certifications/ProfileCertification.vue";
import EducationForm from "@/components/profile/educations/EducationForm.vue";
import CertificationForm from "@/components/profile/certifications/CertificationForm.vue";
import ExperienceForm from "@/components/profile/experiences/ExperienceForm.vue";
import AddWorkSamplesToContractor from "@/components/contractors/AddWorkSamplesToContractorByManagement.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputCustom.vue";
import getStateValidationRules from "@/helpers/locations/stateValidationRules";
import DropdownOption from "@/entities/DropdownOption";
import MaskedPhoneInput from "@/components/common/MaskedPhoneInput.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import GET_USER_PROFILE from "@/apollo/profile/profileDetails/management/GetUserProfile.gql";
import UPDATE_PROFILE_DETAIL from "@/apollo/profile/profileDetails/UpdateProfileDetail.gql";
import UPDATE_PROFILE_ONLY from "@/apollo/profile/profileDetails/UpdateProfileOnly.gql";
import UPDATE_SKILLS_ONLY from "@/apollo/profile/profileDetails/UpdateSkillsOnly.gql";
import CREATE_SKILL from "@/apollo/skills/CreateSkill.gql";
import CREATE_SOFT_SKILL from "@/apollo/skills/CreateSoftSkill.gql";
import UPDATE_SOFT_SKILLS_ONLY from "@/apollo/profile/profileDetails/UpdateSoftSkillsOnly.gql";
import UPDATE_INDUSTRIES_ONLY from "@/apollo/profile/profileDetails/UpdateIndustriesOnly.gql";
import UPDATE_LANGUAGES_ONLY from "@/apollo/profile/profileDetails/UpdateLanguagesOnly.gql";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import countries from "@/data/locations/countries";
import States from "@/entities/locationEntities/States";
import Provinces from "@/entities/locationEntities/Provinces";
import isAllStatesOfPrimaryCountry from "@/helpers/locations/stateOfPrimaryCountry";
import getCountryRelatedValue from "@/helpers/locations/getCountryRelatedValue";
import ExperienceCard from "@/components/profile/experiences/ExperienceCard.vue";
import EducationCard from "@/components/profile/educations/EducationCard.vue";
import CertificationCard from "@/components/profile/certifications/CertifcationCard.vue";
import MailTo from "@/components/common/MailTo.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import UserResume from "@/entities/UserResume";
import UPDATE_USER_JOB_TITLE from "@/apollo/autocomplete-queries/UpdateUserJobTitle.gql";

interface ManagementAddedInfoMode {
  skills: boolean;
  softSkills: boolean;
  industries: boolean;
  languages: boolean;
  workSamples: boolean;
  experience: boolean;
  education: boolean;
  certification: boolean;
  rating: boolean;
  contactInfo: boolean;
  website: boolean;
  company: boolean;
  jobTitle: boolean;
  rate: boolean;
  country: boolean;
  region: boolean;
  city: boolean;
  resume: boolean;
}
interface Observer extends Vue {
  reset: Function;
}
@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    FormWrapper,
    CustomSkillsMultiselectNew,
    CustomSoftSkillsMultiselectNew,
    IndustriesMultiselect,
    LanguagesMultiselect,
    JobTitleMultiselect,
    CurrencySelect,
    RateUnitSelect,
    FormTextarea,
    FormGroup,
    UIButton,
    CrossIcon,
    InputRangeFilter,
    ProfileWebsite,
    ProfileDemoReel,
    ProfileExperience,
    CrossIconHover,
    ProfileEducation,
    ProfileCertification,
    EducationForm,
    CertificationForm,
    ExperienceForm,
    AddWorkSamplesToContractor,
    ProfileCountrySelect,
    RegionInput,
    MaskedPhoneInput,
    ExperienceCard,
    EducationCard,
    CertificationCard,
    LoadingOverlay,
    MailTo,
  },
})
export default class ManagementAddContractorInfo extends Vue {
  @Prop({ type: Object, required: false })
  readonly managementAddedInfoMode?: ManagementAddedInfoMode;
  @Prop({ type: String, required: true }) readonly userId!: string;
  @Prop({ type: Object, required: true })
  readonly profileByManagement!: User_Profile_By_Management;
  @Prop({ type: Array, required: true })
  readonly experiencesByManagement!: User_Experience[];
  @Prop({ type: Array, required: true })
  readonly educationsByManagement!: User_Education[];
  @Prop({ type: Array, required: true })
  readonly certificationsByManagement!: User_Certification[];

  closeModal(): void {
    this.$emit("close");
  }
  isHovered: boolean = false;
  skillsIds: number[] = [];
  newSkillsNames: string[] = [];
  allChosenSkills: any[] = [];
  skillsComponentKey: number = 0;
  softSkillsIds: number[] = [];
  newSoftSkillsNames: string[] = [];
  allChosenSoftSkills: any[] = [];
  softSkillsComponentKey: number = 0;
  industries: Industry[] = [];
  languages: Language[] = [];
  showEducationForm: boolean = false;
  showCertificationForm: boolean = false;
  showExperienceForm: boolean = false;
  showWorkSamplesForm: boolean = false;
  currentUser: User = Vue.prototype.$currentUser;
  country: DropdownOption[] = [];
  countryFromDB: string = this.profileByManagement
    ? this.profileByManagement.country
    : "";
  state: DropdownOption[] = [];
  processing: boolean = false;
  loading: boolean = false;
  phoneTouched: boolean = false;
  skills: User_Skill[] = [];
  softSkills: any[] = [];
  // profileByManagementSet: User_Profile_By_Management = (({ __typename, ...others }) => others)(this.profileByManagement);
  emailHasErrors: boolean = false;
  phoneHasErrors: boolean = false;
  countryHasErrors: boolean = false;
  cityHasErrors: boolean = false;
  // user_id: string = this.profileByManagement ? this.profileByManagement.user_id : '';
  // added_by_id: string = this.profileByManagement ? this.profileByManagement.added_by_id : '';
  email: string = this.profileByManagement
    ? this.profileByManagement.email
    : "";
  phone: number = this.profileByManagement
    ? this.profileByManagement.phone
    : undefined;
  about: string = this.profileByManagement
    ? this.profileByManagement.about
    : "";
  city: string = this.profileByManagement ? this.profileByManagement.city : "";
  company_name: string = this.profileByManagement
    ? this.profileByManagement.company_name
    : "";
  created_at: string = this.profileByManagement
    ? this.profileByManagement.created_at
    : "";
  currency: string = this.profileByManagement
    ? this.profileByManagement.currency
    : "CAD";
  job_title: string = this.profileByManagement
    ? this.profileByManagement.job_title
    : "";
  max_rate: number = this.profileByManagement
    ? this.profileByManagement.max_rate
    : null;
  min_rate: number = this.profileByManagement
    ? this.profileByManagement.min_rate
    : null;
  occupation: string = this.profileByManagement
    ? this.profileByManagement.occupation
    : "";
  postal_code: string = this.profileByManagement
    ? this.profileByManagement.postal_code
    : "";
  rate_unit: string = this.profileByManagement
    ? this.profileByManagement.rate_unit
    : "hour";
  resume = this.profileByManagement ? this.profileByManagement.resume : null;
  summary: string = this.profileByManagement
    ? this.profileByManagement.summary
    : "";
  updated_at: string = this.profileByManagement
    ? this.profileByManagement.updated_at
    : "";
  website: string = this.profileByManagement
    ? this.profileByManagement.website
    : "";
  work_samples: string[] = this.profileByManagement
    ? this.profileByManagement.work_samples
    : [];
  year_of_experience: number = this.profileByManagement
    ? this.profileByManagement.year_of_experience
    : undefined;
  selectedJobTitle: DropdownOption[] = [];

  created(): void {
    if (this.managementAddedInfoMode.skills) {
      this.getSkills();
    }
    if (this.managementAddedInfoMode.softSkills) {
      this.getSoftSkills();
    }
    if (this.managementAddedInfoMode.industries) {
      this.getIndustries();
    }
    if (this.managementAddedInfoMode.languages) {
      this.getLanguages();
    }
    if (this.managementAddedInfoMode.jobTitle) {
      this.initializeJobTitle();
    }

    if (this.profileByManagement.country) {
      this.country = countries.filter(({ name }) => {
        const countryName = name.toLowerCase();
        const searchValue = this.profileByManagement.country.toLowerCase();
        return countryName.includes(searchValue);
      });
    }

    if (this.primaryCountry) {
      this.state = getCountryRelatedValue<DropdownOption[]>({
        countries: this.country,
        primary: [],
        onlyUSA: this.filterMatchingOptions(
          this.states,
          this.profileByManagement.state
        ),
        onlyCanada: this.filterMatchingOptions(
          this.provinces,
          this.profileByManagement.state
        ),
        defaultValue: [],
      });
    } else {
      this.state.push({
        id: this.profileByManagement.state,
        name: this.profileByManagement.state,
      });
    }
  }

  get primaryCountry(): boolean {
    const countryNames = this.country.map((country) => country.name);
    return isAllStatesOfPrimaryCountry(countryNames);
  }

  filterMatchingOptions(options: DropdownOption[], searchString: string) {
    return options.filter((option) =>
      this.hasSearchValue(option.name, searchString)
    );
  }

  hasSearchValue(optionName: string, searchString: string) {
    return optionName.toLowerCase().includes(searchString.toLowerCase());
  }

  states: DropdownOption[] = (
    Object.keys(States) as Array<keyof typeof States>
  ).map((key) => {
    return {
      id: States[key],
      name: States[key],
    };
  });

  provinces: DropdownOption[] = (
    Object.keys(Provinces) as Array<keyof typeof Provinces>
  ).map((key) => {
    return {
      id: Provinces[key],
      name: Provinces[key],
    };
  });

  async getSkills(): Promise<void> {
    this.loading = true;
    let query = await this.$apollo.query({
      query: GET_USER_PROFILE,
      variables: {
        id: this.userId,
      },
      fetchPolicy: "no-cache",
    });
    this.skills = query?.data?.user_profile_by_pk?.skills || [];
    if (this.skills) {
      this.skillsIds = this.skills.map((skill) => {
        return skill.skill.id;
      });
    }
    this.loading = false;
  }

  async handleSkillsListUpdated(skillsIdsFromDB: number[], newSkillsNames: string[], allChosenSkills: any[]): Promise<void> {
    this.newSkillsNames = newSkillsNames;
    this.allChosenSkills = allChosenSkills;
    
    // Create new skills immediately and update the selected list
    if (newSkillsNames.length > 0) {
      try {
        const createdSkills = await this.createSkillsInDatabase(newSkillsNames);
        const newSkillIds = createdSkills.map(skill => skill.id);
        
        // Update the skillsIds to include both existing and newly created skills
        this.skillsIds = [...skillsIdsFromDB, ...newSkillIds];
        
        // Clear new skills names since they're now created
        this.newSkillsNames = [];
        
        // Force component to re-render with updated skills
        this.skillsComponentKey += 1;
        
      } catch (error) {
        console.error('Error creating new skills:', error);
        // Keep the original skillsIds on error
        this.skillsIds = skillsIdsFromDB;
      }
    } else {
      this.skillsIds = skillsIdsFromDB;
    }
  }

  private async createSkillsInDatabase(skillNames: string[]): Promise<any[]> {
    if (skillNames.length === 0) return [];

    try {
      const skillObjects = skillNames.map((name) => ({
        name,
        company_id: this.currentUser.admin ? this.currentUser.admin.company.id : this.currentUser.manager.company_id
      }));

      const response = await this.$apollo.mutate({
        mutation: CREATE_SKILL,
        variables: {
          objects: skillObjects,
        },
      });

      return response.data.insert_skill.returning;
    } catch (error) {
      console.error('Error creating skills:', error);
      throw error;
    }
  }

  async upsertSkills(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: UPDATE_SKILLS_ONLY,
      variables: {
        userId: this.userId,
        skillsSet: this.userSkills,
      },
    });
    this.processing = false;
    this.closeModalAndRefreshContractor();
  }

  async getSoftSkills(): Promise<void> {
    this.loading = true;
    let query = await this.$apollo.query({
      query: GET_USER_PROFILE,
      variables: {
        id: this.userId,
      },
      fetchPolicy: "no-cache",
    });
    this.softSkills = query?.data?.user_profile_by_pk?.user_soft_skills || [];
    if (this.softSkills) {
      this.softSkillsIds = this.softSkills.map((userSoftSkill) => {
        return userSoftSkill.soft_skill.id;
      });
    }
    this.loading = false;
  }

  async handleSoftSkillsListUpdated(softSkillsIdsFromDB: number[], newSoftSkillsNames: string[], allChosenSoftSkills: any[]): Promise<void> {
    this.newSoftSkillsNames = newSoftSkillsNames;
    this.allChosenSoftSkills = allChosenSoftSkills;
    
    // Create new soft skills immediately and update the selected list
    if (newSoftSkillsNames.length > 0) {
      try {
        const createdSoftSkills = await this.createSoftSkillsInDatabase(newSoftSkillsNames);
        const newSoftSkillIds = createdSoftSkills.map(softSkill => softSkill.id);
        
        // Update the softSkillsIds to include both existing and newly created soft skills
        this.softSkillsIds = [...softSkillsIdsFromDB, ...newSoftSkillIds];
        
        // Clear new soft skills names since they're now created
        this.newSoftSkillsNames = [];
        
        // Force component to re-render with updated soft skills
        this.softSkillsComponentKey += 1;
        
      } catch (error) {
        console.error('Error creating new soft skills:', error);
        // Keep the original softSkillsIds on error
        this.softSkillsIds = softSkillsIdsFromDB;
      }
    } else {
      this.softSkillsIds = softSkillsIdsFromDB;
    }
  }

  private async createSoftSkillsInDatabase(softSkillNames: string[]): Promise<any[]> {
    if (softSkillNames.length === 0) return [];
    
    try {
      const softSkillObjects = softSkillNames.map((name) => ({
        name,
        company_id: this.currentUser.admin ? this.currentUser.admin.company.id : this.currentUser.manager.company_id
      }));

      const response = await this.$apollo.mutate({
        mutation: CREATE_SOFT_SKILL,
        variables: {
          objects: softSkillObjects,
        },
      });

      return response.data.insert_soft_skill.returning;
    } catch (error) {
      console.error('Error creating soft skills:', error);
      throw error;
    }
  }

  async upsertSoftSkills(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: UPDATE_SOFT_SKILLS_ONLY,
      variables: {
        userId: this.userId,
        softSkillsSet: this.userSoftSkills,
      },
    });
    this.processing = false;
    this.closeModalAndRefreshContractor();
  }

  async getIndustries(): Promise<void> {
    this.loading = true;
    let query = await this.$apollo.query({
      query: GET_USER_PROFILE,
      variables: {
        id: this.userId,
      },
      fetchPolicy: "no-cache",
    });
    this.industries = query?.data?.user_profile_by_pk?.industries?.map(
      (industry: User_Industry) => industry.industry
    ) || [];
    this.loading = false;
  }

  async upsertIndustries(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: UPDATE_INDUSTRIES_ONLY,
      variables: {
        userId: this.userId,
        industriesSet: this.userIndustries,
        added_by_id: this.currentUser.id,
      },
    });
    this.processing = false;
    this.closeModalAndRefreshContractor();
  }

  async getLanguages(): Promise<void> {
    this.loading = true;
    let query = await this.$apollo.query({
      query: GET_USER_PROFILE,
      variables: {
        id: this.userId,
      },
      fetchPolicy: "no-cache",
    });
    this.languages = query?.data?.user_profile_by_pk?.languages?.map(
      (language: User_Language) => language.language
    ) || [];
    this.loading = false;
  }

  async upsertLanguages(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: UPDATE_LANGUAGES_ONLY,
      variables: {
        userId: this.userId,
        languagesSet: this.userLanguages,
        added_by_id: this.currentUser.id,
      },
    });
    this.processing = false;
    this.closeModalAndRefreshContractor();
  }

  async upsertProfileByManagement(): Promise<void> {
    this.processing = true;
    let profileSet = {
      about: this.about,
      city: this.city,
      company_name: this.company_name,
      currency: this.currency,
      job_title: this.job_title,
      max_rate: this.max_rate ? this.max_rate : null,
      min_rate: this.min_rate ? this.min_rate : null,
      occupation: this.occupation,
      postal_code: this.postal_code,
      rate_unit: this.rate_unit,
      resume: this.resume,
      summary: this.summary,
      website: this.website,
      work_samples: !!this.work_samples
        ? !!this.work_samples.length
          ? this.work_samples
          : null
        : null,
      year_of_experience: this.year_of_experience,
      country: this.countryName,
      state: this.state[0]?.name || "",
    };
    await this.$apollo.mutate({
      mutation: UPDATE_PROFILE_ONLY,
      variables: {
        userId: this.userId,
        set: profileSet,
      },
    });
    this.processing = false;
    window.location.reload();
    this.$emit("refetchProfileByManagement");
    this.closeModal();
  }

  @Watch("countryName", { immediate: false })
  clearCountry(newCountry: string): void {
    if (newCountry !== this.countryFromDB || !Boolean(newCountry)) {
      this.state = [];
      this.city = "";
      this.postal_code = "";
    }
  }

  get countryName(): string {
    return this.country[0]?.name || "";
  }

  get userIndustries(): Partial<User_Industry>[] {
    return this.industries.map(({ id }) => ({
      user_id: this.userId,
      industry_id: id,
      added_by_id: this.currentUser.id,
    }));
  }

  get userSkills(): Partial<User_Skill>[] {
    return this.skillsIds.map((skillId) => ({
      user_id: this.userId,
      skill_id: skillId,
      added_by_id: this.currentUser.id,
    }));
  }

  get userSoftSkills(): any[] {
    return this.softSkillsIds.map((softSkillId) => ({
      user_id: this.userId,
      soft_skill_id: softSkillId,
      added_by_id: this.currentUser.id,
    }));
  }

  get userLanguages(): Partial<User_Language>[] {
    return this.languages.map(({ id }) => ({
      user_id: this.userId,
      language_id: id,
      added_by_id: this.currentUser.id,
    }));
  }

  get stateValidationRules(): string | undefined {
    return getStateValidationRules(this.countryName);
  }

  get companyId(): string | null {
    return this.currentUser.admin ? this.currentUser.admin.company.id : this.currentUser.manager.company_id;
  }

  intercomNewMessage(): void {
    // @ts-ignore
    Intercom("showNewMessage", "Skills to add: ");
  }

  async updateUserJobTitle(): Promise<void> {
    this.processing = true;
    try {
      await this.$apollo.mutate({
        mutation: UPDATE_USER_JOB_TITLE,
        variables: {
          userId: this.userId,
          userJobId: this.selectedJobTitle.length > 0 ? this.selectedJobTitle[0].id : null,
        },
      });
      this.processing = false;
      this.closeModal();
      // Reload the page to ensure all data is refreshed with the new job title
      window.location.reload();
    } catch (error) {
      console.error('Error updating job title:', error);
      this.processing = false;
    }
  }

  initializeJobTitle(): void {
    // Check if profile has user_job_title data (using type assertion since generated types may not be up to date)
    const profileWithJobTitle = this.profileByManagement as any;
    if (profileWithJobTitle?.user_job_title) {
      this.selectedJobTitle = [{
        id: profileWithJobTitle.user_job_title.id,
        name: profileWithJobTitle.user_job_title.job_title
      }];
    }
  }

  handleJobTitleSelection(selectedOptions: DropdownOption[]): void {
    // Ensure only one job title can be selected
    if (selectedOptions.length > 1) {
      // Keep only the most recently selected option
      this.selectedJobTitle = [selectedOptions[selectedOptions.length - 1]];
    } else {
      this.selectedJobTitle = selectedOptions;
    }
  }

  closeModalAndRefreshContractor(): void {
    this.$emit("refreshContractor");
    this.closeModal();
  }
}
